export default __webpack_public_path__ + "static/media/11.b70f89a1.png";